<template>
  <div>
    <v-icon v-if="flag == 3" :color="'error'" class="center" x-medium>
      mdi-text-box-multiple-outline
    </v-icon>
    <v-icon v-if="flag == 2" :color="'orange'" class="center" x-medium>
      mdi-text-box-multiple-outline
    </v-icon>
    <v-icon v-if="flag == 1" :color="'success'" class="center" x-medium>
      mdi-text-box-multiple-outline
    </v-icon>
  </div>
</template>

<script>
export default {
   props: {
      flag: {
         type: Number,
         required: true,
      }
   }
}
</script>

<style>
</style>
